import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { COMPANIES_PATHS } from '../../companies';
import { Enums } from '../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.scss'],
  standalone: false,
})
export class CompaniesListComponent implements OnInit {
  public COMPANIES_PATHS = COMPANIES_PATHS;
  public Enums = Enums;

  @Input() filter;
  @Input() companiesTable;
  @Input() dataLoading;

  constructor() {}

  ngOnInit() {}
}
